export default function TaskName({ taskName }) {
  if (!taskName) return null;

  return (
    <div>
      <span className="label">Work: </span>
      <span className="value">
        {`${taskName}`.charAt(0).toUpperCase()}
        <span className="text-xs">{`${taskName}`.slice(1)}</span>
      </span>
    </div>
  );
}
